import AbstractAnimation from "./abstract-animation";

export default class OpenDesktopNavigation extends AbstractAnimation
{
    create(): any {
        let $overlay = $('.l-overlay');
        this.$element
            .removeAttr('hidden')
            .attr('aria-expanded', 'true')
            // .css('opacity', 0)
        ;
        $overlay.addClass('l-overlay--active');
        let targetHeight = this.$element.height();
        // this.$element.height(targetHeight * 0.9)
        this.$element.height(0)
        return this
            .timeline
            .to($overlay, { duration: 0.2, opacity: 0.75 }, 0)
            .to(this.$element, { duration:0.4, height: targetHeight, ease: 'Power2.easeOut' }, 0)
            // .to(this.$element, 0.1, { opacity: 1, ease: 'sine.easeOut' }, 0)
            .set(this.$element, { clearProps: 'opacity,height' })
        ;
    }
}